import { defineMessages } from 'react-intl'

const scope = `procurify.components.WithTermsAndConditionsFooter`

export default defineMessages({
  termsAndConditionsText: {
    id: `${scope}.termsAndConditionsText`,
    defaultMessage:
      'By using these payment services, you agree to T&Cs <a>here</a>. Payment services are provided in the UK by Airwallex (UK) Limited, an electronic money institution authorised by the Financial Conduct Authority with registration number 900876.',
  },
})
